import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import './NotificationBell.css';

const API_URL = 'https://unbot.io/api/v1.0/notification';
const POLLING_INTERVAL = 10_000;
const ALERT_SOUND_URL = 'https://www.myinstants.com/media/sounds/ka-ching.mp3';

const formatNotificationMessage = (notif) => {
  if (!notif) return 'Notification';
  if (notif.type === 'potential_sale') {
    return `Une vente est à faire au fan ${notif.fan_username} sur le compte ${notif.model_username}`;
  }
  else if (notif.type === 'affiliate_credit') {
      return `Vous avez reçu ${notif.credit_number} crédits grâce à un de vos filleuls.`;

  }
  else if (notif.type === 'no_media_available') {
      return `L'agent n'a aucun média disponible à vendre pour le fan ${notif.fan_username} sur le compte ${notif.model_username}`;
  }
  else if (notif.type === 'no_credit') {
      return `Votre modèle ${notif.model_username} n'a plus de crédit. Veuillez changer d'abonnement pour continuer à utiliser l'agent.`;
  }
  else if (notif.type === 'low_credit') {
      return `Votre modèle ${notif.model_username} n'a presque plus de crédit. Pensez à changer d'abonnement pour éviter toute interruption de l'agent.`;
  }


  return notif.message || notif.content || 'Notification';
};

const NotificationBell = () => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unseenCount, setUnseenCount] = useState(0);
  const [toastNotif, setToastNotif] = useState(null);
  const [modalNotif, setModalNotif] = useState(null);

  const prevCountRef = useRef(0);
  const audioRef = useRef(typeof Audio !== 'undefined' ? new Audio(ALERT_SOUND_URL) : null);
  const jwt = Cookies.get('user_token');

  const fetchNotifications = async (onlyUnseen = false) => {
    if (!jwt) return;
    try {
      const response = await axios.get(`${API_URL}${onlyUnseen ? '?unseen_only=true' : ''}`, {
        headers: { Authorization: `Bearer ${jwt}` }
      });
      const notifs = response.data || [];

      if (onlyUnseen) {
        setUnseenCount(notifs.length);

        if (notifs.length > prevCountRef.current) {
          if (audioRef.current) {
            try { audioRef.current.play().catch(() => {});} catch(_e) {}
          }
          // Afficher en modal si pop_up_display est true, sinon en toast
          if (notifs[0]?.pop_up_display === true) {
            setModalNotif(notifs[0]);
          } else {
            setToastNotif(notifs[0]);
          }
        }

        prevCountRef.current = notifs.length;
      }else{
        setNotifications(notifs);
      }
    } catch (e) {
      console.error('Erreur lors de la récupération des notifications', e);
    }
  };

  useEffect(() => {
    fetchNotifications(true);
    const interval = setInterval(() => fetchNotifications(true), POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []); 


  useEffect(() => {
    if (!toastNotif) return;
    const timer = setTimeout(() => setToastNotif(null), 15_000);
    return () => clearTimeout(timer);
  }, [toastNotif]);

  const handleToggle = async () => {
    const newOpen = !open;
    setOpen(newOpen);
    if (newOpen) {
      await fetchNotifications(false);
      setUnseenCount(0);
    }
  };

  return (
    <div className="notification-bell">
      <button
        type="button"
        className="notification-bell-float"
        aria-label="Notifications"
        aria-expanded={open}
        onClick={handleToggle}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
        </svg>
        {unseenCount > 0 && <div className="notification-badge">{unseenCount}</div>}
      </button>
      {open && (
        <div className="notification-panel">
          <div className="notification-header">
            <span>Notifications</span>
            <button className="notification-close" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="notification-empty">Aucune notification</div>
            ) : (
              notifications.map((notif, idx) => (
                <div key={idx} className="notification-item">
                  <div className="notification-content">{formatNotificationMessage(notif)}</div>
                  <div className="notification-date">{notif.created_at ? new Date(notif.created_at).toLocaleString() : ''}</div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
      {toastNotif && (
        <div className="notification-toast" onClick={() => { setOpen(true); setToastNotif(null); }}>
          {formatNotificationMessage(toastNotif)}
        </div>
      )}
      {modalNotif && (
        <div className="notification-modal-overlay" onClick={() => setModalNotif(null)}>
          <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
            <div className="notification-modal-header">
              <span>
                {modalNotif.type === 'potential_sale' && '💰 Opportunité de vente'}
                {modalNotif.type === 'affiliate_credit' && '🎉 Crédits d\'affiliation'}
                {modalNotif.type === 'no_media_available' && '⚠️ Aucun média disponible'}
                {modalNotif.type === 'no_credit' && '❌ Crédit épuisé'}
                {modalNotif.type === 'low_credit' && '⚡ Crédit faible'}
                {!modalNotif.type && '🔔 Notification'}
              </span>
              <button className="notification-modal-close" onClick={() => setModalNotif(null)}>×</button>
            </div>
            <div className="notification-modal-body">
              <div className="notification-modal-icon">
                {modalNotif.type === 'potential_sale' && '💰'}
                {modalNotif.type === 'affiliate_credit' && '🎉'}
                {modalNotif.type === 'no_media_available' && '⚠️'}
                {modalNotif.type === 'no_credit' && '❌'}
                {modalNotif.type === 'low_credit' && '⚡'}
                {!modalNotif.type && '🔔'}
              </div>
              <div className="notification-modal-message">
                {formatNotificationMessage(modalNotif)}
              </div>
            </div>
            <div className="notification-modal-footer">
              <button className="notification-modal-button" onClick={() => setModalNotif(null)}>Compris</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
